import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Activity, LogOut } from "lucide-react";

export default function Navbar({ transparent = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className={`sticky top-0 z-40 ${
        transparent ? "bg-white/60 backdrop-blur-xl border-b border-white/40" : "bg-white border-b border-slate-200"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group cursor-pointer" data-testid="nav-logo">
          <div className="relative h-8 w-8 rounded-xl bg-slate-900 flex items-center justify-center">
            <Activity className="h-4 w-4 text-sky-200" strokeWidth={2.5} />
            <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-emerald-300 ring-2 ring-white pulse-ring" />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-heading text-[15px] font-semibold tracking-tight text-slate-900">
              Shushrut<span className="text-sky-500">.</span>AI
            </span>
            <span className="text-[9px] uppercase tracking-[0.22em] text-slate-400 font-mono-num">
              Dermatology Agent
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600 font-medium">
          <a href="/#features" className="hover:text-slate-900 transition-colors cursor-pointer" data-testid="nav-features">Features</a>
          <a href="/#how-it-works" className="hover:text-slate-900 transition-colors cursor-pointer" data-testid="nav-how">How it works</a>
          <a href="/#architecture" className="hover:text-slate-900 transition-colors cursor-pointer" data-testid="nav-architecture">Architecture</a>
          <a href="/#performance" className="hover:text-slate-900 transition-colors cursor-pointer" data-testid="nav-performance">Performance</a>
        </nav>

        <div className="flex items-center gap-2">
          {user && user !== false ? (
            <>
              <Link to="/dashboard">
                <Button variant="outline" size="sm" className="rounded-full border-slate-300" data-testid="nav-dashboard-btn">
                  Dashboard
                </Button>
              </Link>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                className="rounded-full"
                data-testid="nav-logout-btn"
              >
                <LogOut className="h-4 w-4 mr-1" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="hidden sm:block">
                <Button variant="ghost" size="sm" className="rounded-full text-slate-700" data-testid="nav-login-btn">
                  Sign in
                </Button>
              </Link>
              <Link to="/register">
                <Button
                  size="sm"
                  className="rounded-full bg-slate-900 hover:bg-slate-800 text-white px-4"
                  data-testid="nav-register-btn"
                >
                  Get started
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
